import { Col, Flex, Row } from "antd";

import { DossierSummary } from "@/pages/admin/dossiers/components/dossier-summary";
import { DriverCard } from "@/pages/admin/dossiers/components/driver-card";
import { DossierCard } from "@/pages/admin/dossiers/components/dossier-card";
import { ServicePartnersCard } from "@/pages/admin/dossiers/components/servicepartner-card";
import { VehicleHandInLocationCard } from "@/pages/admin/dossiers/components/vehicle-handin-location-card";
import { InsuranceCompanyCard } from "@/pages/admin/dossiers/components/insurance-company-card";
import { DealershipCompanyCard } from "@/pages/admin/dossiers/components/dealership-company-card";
import { AppointmentsCard } from "@/pages/admin/dossiers/components/appointments-card";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { AgentDossierActionsCard } from "../components/AgentDossierActionsCard";
import { AgentDossierKnowledgeBaseSummaryCard } from "../components/AgentDossierKnowledgeBaseSummaryCard";
import { MediaCard } from "@/pages/admin/dossiers/components/media-card";
import { AgentDossierCorrespondenceCard } from "../components/AgentDossierCorrespondenceCard";

export const AgentDossierOverviewTab = ({
  data,
  isLoading,
  setActiveTab,
}: {
  data: Dossier | undefined;
  isLoading: boolean;
  setActiveTab: (tabKey: string) => void;
}) => {
  const hasRequestSent = data?.dossierUsageEmailSentDriver.some(
    (email) =>
      email.emailSent?.subjectWithoutStatementsAndExpressions ===
      "Verzoek foto\u0027s aanleveren",
  );

  return (
    <Row gutter={[16, 16]}>
      <Col span={16}>
        <DossierSummary dossier={data} isLoading={isLoading} />
      </Col>
      <Col span={8}>
        {!hasRequestSent && (
          <AgentDossierActionsCard dossier={data} isLoading={isLoading} />
        )}
      </Col>
      <Col xxl={{ span: 12 }} span={24}>
        <Flex vertical gap={16}>
          <DossierCard dossier={data} isLoading={isLoading} />
          <MediaCard dossier={data} isLoading={isLoading} />
          <DriverCard driver={data?.driver} isLoading={isLoading} />
        </Flex>
      </Col>
      {data?.leaseCompany?.name === "Athlon" ? (
        <Col xxl={{ span: 12 }} span={24}>
          <AgentDossierKnowledgeBaseSummaryCard
            isLoading={isLoading}
            setActiveTab={setActiveTab}
          />
        </Col>
      ) : null}
      <Col xxl={{ span: 12 }} span={24}>
        <Flex vertical gap={16}>
          {/* <DossierTimelineCard dossier={data} isLoading={isLoading} /> */}
          <AppointmentsCard dossier={data} isLoading={isLoading} />
          <ServicePartnersCard
            servicePartners={data?.servicePartners}
            isLoading={isLoading}
          />
          <InsuranceCompanyCard
            insuranceCompany={data?.insuranceCompany}
            isLoading={isLoading}
          />
          <DealershipCompanyCard
            dealershipCompany={data?.dealershipCompany}
            isLoading={isLoading}
          />
          <VehicleHandInLocationCard dossier={data} isLoading={isLoading} />
        </Flex>
      </Col>
      <Col xxl={{ span: 12 }} span={24}>
        <AgentDossierCorrespondenceCard dossier={data} isLoading={isLoading} />
      </Col>
    </Row>
  );
};
